<ng-template [vbCssRules]="themeStyleOverrides"></ng-template>

<ng-content></ng-content>

<ng-template #ratingTemplate let-i="index" let-v="value">
	<span class="glyphicons star" [ngClass]="[templateClass ? templateClass : '', i < v ? 'active' : '']"></span>
</ng-template>
